import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ChallengeRunner from "@/components/ChallengeRunner";
import { Markdown } from "@/components/Markdown";

const DIFFICULTY_LABEL = { easy: "Leicht", medium: "Mittel", hard: "Schwer" };

export default function ChallengeDetail() {
  const { id } = useParams();
  const { refreshUser } = useAuth();
  const [challenge, setChallenge] = useState(null);

  useEffect(() => {
    api.get(`/challenges/${id}`).then((r) => setChallenge(r.data)).catch(() => {});
  }, [id]);

  const handleResult = async (result) => {
    if (result.xp_awarded > 0) {
      await refreshUser();
      setChallenge((prev) => (prev ? { ...prev, solved: true } : prev));
    }
  };

  if (!challenge) return <div className="font-bold">Lädt...</div>;

  return (
    <div className="space-y-6" data-testid="challenge-detail">
      <Link to="/challenges" className="inline-flex items-center gap-1 font-bold text-sm hover:underline" data-testid="back-to-challenges">
        <ArrowLeft className="h-4 w-4" strokeWidth={2.5} /> Alle Challenges
      </Link>

      <div className="nb-card p-6 sm:p-8">
        <div className="flex flex-wrap items-center gap-2 mb-2">
          <span className="text-xs font-bold uppercase bg-muted border-2 border-black rounded-full px-2.5 py-0.5">{challenge.language}</span>
          <span className="text-xs font-bold uppercase bg-muted border-2 border-black rounded-full px-2.5 py-0.5">
            {DIFFICULTY_LABEL[challenge.difficulty] || challenge.difficulty}
          </span>
          {challenge.solved && (
            <span className="flex items-center gap-1 text-xs font-bold uppercase bg-success border-2 border-black rounded-full px-2.5 py-0.5">
              <CheckCircle2 className="h-3.5 w-3.5" strokeWidth={2.5} /> Gelöst
            </span>
          )}
        </div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight mb-3">{challenge.title}</h1>
        <Markdown>{challenge.description_md}</Markdown>
      </div>

      <ChallengeRunner
        language={challenge.language}
        starterCode={challenge.starter_code}
        submitUrl={`/challenges/${id}/submit`}
        onResult={handleResult}
      />
    </div>
  );
}
